import { useEffect, useRef, useState } from 'react'

import { Grid, Paper } from '@material-ui/core'
import {
  useParams
} from 'react-router-dom/cjs/react-router-dom.min'
import ConfirmationModal from '../../components/ConfirmationModal'
import DepartmentOptionsFlow from '../../components/DepartmentOptionsFlow'
import MainContainer from '../../components/MainContainer'
import ProtectedRoute from '../../components/ProtectedRoute'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { useStyles } from './styles'

const initialState = {
  name: '',
  description: '',
  greetingMessage: '',
  mediaPath: null,
  mediaName: null
}

const DepartmentsFlow = () => {
  const classes = useStyles()

  const { queueId } = useParams()
  // const { user } = useContext(AuthContext)
  // const history = useHistory()

  const [attachment, setAttachment] = useState(null)
  const attachmentFile = useRef(null)
  const [confirmationOpen, setConfirmationOpen] = useState(false)

  const [, setOptions] = useState([])

  const [queue, setQueue] = useState(initialState)

  useEffect(() => {
    const fetchDepartmentData = async () => {
      if (!queueId) {
        setQueue(initialState)
        setOptions([]) // Reseta as opções
        return
      }

      try {
        const { data: queueData } = await api.get(`/queue/${queueId}`)
        setQueue(queueData)

        const { data: optionsData } = await api.get(`/queue-options`, {
          params: { queueId, parentId: -1 }
        })

        // Lógica para construir a árvore de opções (recursiva)
        const buildOptionTree = async list => {
          for (const option of list) {
            const { data: childrenData } = await api.get(`/queue-options`, {
              params: { queueId, parentId: option.id }
            })
            option.children = await buildOptionTree(childrenData)
          }
          return list
        }

        const optionTree = await buildOptionTree(optionsData)
        setOptions(optionTree)
      } catch (err) {
        toastError(err)
      }
    }
    fetchDepartmentData()
  }, [queueId])

  const deleteMedia = async () => {
    if (attachment) {
      setAttachment(null)
      attachmentFile.current.value = null
    }
    if (queue.mediaPath) {
      await api.delete(`/queue/${queue.id}/media-upload`)
      setQueue(prev => ({ ...prev, mediaPath: null, mediaName: null }))
    }
    setConfirmationOpen(false)
  }

  // const handleBackToDepartments = () => {
  //   history.push('/departments')
  // }

  return (
    <ProtectedRoute
      requiredRoles={['super', 'admin', 'departamentos']}
      fallbackPath="/tickets"
    >
      <MainContainer>
        {/* <MainHeader
          title="Crie o Fluxo de Atendimento"
          showTutorial
        ></MainHeader> */}
        <Paper className={classes.mainPaper}>
          <ConfirmationModal
            title="Deletar Anexo"
            open={confirmationOpen}
            onClose={() => setConfirmationOpen(false)}
            onConfirm={deleteMedia}
          >
            Tem certeza de que deseja excluir o anexo? Esta ação não pode ser
            desfeita.
          </ConfirmationModal>

          <Grid container>
            <DepartmentOptionsFlow queueId={queueId} />
          </Grid>
        </Paper>
      </MainContainer>
    </ProtectedRoute>
  )
}

export default DepartmentsFlow
